/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */

// Imports

import { AutoAddMomentToTraceiDWrapper } from "../AutoAddMomentToTraceiDWrapper"
import { ContentSection, Modal } from "trux"
import React from "react"

import "./AutoAddMomentToTraceiDDialog.css"

// Auto Add Moment To TraceiD Dialog

const AutoAddMomentToTraceiDDialog = ({ token, open, title, team, moment, forceAutoAdd, disableAutoAdd, onClose }) => {

    return (
        <Modal
            trkContext="Auto Add Moment to TraceiD Dialog"
            className="AutoAddMomentToTraceiDDialog"
            open={open}
            onShadeClick={onClose}
        >
            <ContentSection>
                <AutoAddMomentToTraceiDWrapper 
                    team={team}
                    title={title}
                    token={token}
                    moment={moment}
                    onClose={onClose}
                    forceAutoAdd={forceAutoAdd}
                    disableAutoAdd={disableAutoAdd}
                />
            </ContentSection>
        </Modal>
    )
}

AutoAddMomentToTraceiDDialog.defaultProps = {
    forceAutoAdd: false,
    disableAutoAdd: false, 
}

export { AutoAddMomentToTraceiDDialog}